import { useMutation } from "@apollo/client";

import { gql } from "~/__generated__";

const NOTIFICATION_UPDATE_IS_READ = gql(`
  mutation NotificationUpdateIsRead($input: GqlNotificationMarkAsReadInput!) {
    notificationUpdateIsRead(input: $input)
  }
`);

export default function useNotificationUpdateIsRead() {
    const [updateIsRead, { data, loading, error }] = useMutation(NOTIFICATION_UPDATE_IS_READ);

    return {
        updateIsRead: (notificationIds: string[]) => updateIsRead({ variables: { input: { notificationIds } } }),
        loading,
        error,
        data: data?.notificationUpdateIsRead,
    };
}
